import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { useUserSessionStore } from '../../stores/UserSession.store';
import { UserTypeEnum } from '../../@core/enums/UserType.enum';

export interface CommonLayoutProps {
  children?: React.ReactNode;
}

const CommonLayout: FC<CommonLayoutProps> = ({ children }) => {
  const user = useUserSessionStore((state) => state.user);

  const renderNavLink = (to: string, label: string) => (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `block py-5 px-5 border-b-2 flex-shrink-0 ${
          !isActive ? 'border-transparent' : 'border-primary-500'
        }`
      }
    >
      {label}
    </NavLink>
  );

  const userLinks = [
    { to: '/account', label: 'Account Info' },
    { to: '/account-orders', label: 'Orders' },
    { to: '/account-saved-services', label: 'Saved Services' },
    { to: '/account-password', label: 'Change Password' },
    { to: '/account-reservations', label: 'Reservations' }
  ];

  const providerLinks = [
    { to: '/account', label: 'Provider Info' },
    { to: '/account-provider-orders', label: 'Provider Orders' },
    { to: '/account-provider-services', label: 'Provider Services' },
    { to: '/account-reservations', label: 'Reservations' },
    { to: '/account-agenda', label: 'Agenda' },
  ];

  const companyLinks = [
    { to: '/account', label: 'Company Info' },
    { to: '/account-password', label: 'Change Password' },
    { to: '/account-reservations', label: 'Reservations' },
    { to: '/account-agenda', label: 'Agenda' },
  ];

  return (
    <div className="nc-CommonLayoutProps bg-neutral-50 dark:bg-neutral-900">
      <div className="border-b border-neutral-200 dark:border-neutral-700 pt-12 bg-white dark:bg-neutral-800">
        <div className="container">
          <div className="flex flex-wrap overflow-x-auto hiddenScrollbar">
            {user.role === UserTypeEnum.USER &&
              userLinks.map((link) => renderNavLink(link.to, link.label))}
            {user.role === UserTypeEnum.PROVIDER &&
              providerLinks.map((link) => renderNavLink(link.to, link.label))}
            {user.role === UserTypeEnum.COMPANY &&
              companyLinks.map((link) => renderNavLink(link.to, link.label))}
          </div>
        </div>
      </div>
      <div className="container pt-14 sm:pt-20 pb-24 lg:pb-32">{children}</div>
    </div>
  );
};

export default CommonLayout;
